import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import styled, { keyframes } from "styled-components";
import { colors, size } from "../../shared/constants";
export var SkeletonUnit;
!function (e) {
  e.Percentage = "%", e.Pixel = "px";
}(SkeletonUnit || (SkeletonUnit = {}));
export var SkeletonShape;
!function (e) {
  e.Rectangle = "Rectangle", e.Circle = "Circle";
}(SkeletonShape || (SkeletonShape = {}));

var shimmerAnimation = function shimmerAnimation(e) {
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    background-position: -", "px 0;\n  }\n  \n  100% {\n    background-position: calc(", "px + 100%) 0;\n  }\n"])), e, e);
},
    getHeight = function getHeight(e) {
  return "".concat(e.height.value).concat(e.height.unit ? e.height.unit : "px");
},
    getWidth = function getWidth(e) {
  return "".concat(e.width.value).concat(e.width.unit ? e.width.unit : "px");
},
    getBackgroundWidth = function getBackgroundWidth(e) {
  return Math.max(e / 2, 150);
};

export var StyledSkeletonContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  background-image: linear-gradient(\n    90deg,\n    ", ",\n    ", ",\n    ", ",\n    ", "\n  );\n  background-size: ", "px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  animation: ", "\n    ", "s ease-in-out infinite;\n  height: ", ";\n  width: ", ";\n  border-radius: ", ";\n"])), colors.gray2, colors.gray2, colors.gray1, colors.gray2, colors.gray2, function (e) {
  return getBackgroundWidth(e.realWidth);
}, function (e) {
  return t = getBackgroundWidth(e.realWidth), keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    background-position: -", "px 0;\n  }\n  \n  100% {\n    background-position: calc(", "px + 100%) 0;\n  }\n"])), t, t);
  var t;
}, function (e) {
  return e.duration ? e.duration : 1;
}, function (e) {
  return getHeight(e);
}, function (e) {
  return getWidth(e);
}, function (e) {
  return e.shape === SkeletonShape.Circle ? "50%" : size.xs2 + "px";
});